import { Box, Text, ThemeContext } from '@vouched.id/vault';
import React, { useContext } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import { JobStatusLabel } from './JobStatusLabel';
import { ReviewedCheckbox } from './ReviewedCheckbox';
import { humanDate } from 'utils/ui.utils';
const Label = ({ text, color }) => (React.createElement(Text, { style: {
        color,
        textTransform: 'uppercase',
        marginBottom: '10px'
    }, variation: "footnote" }, text));
export const JobStatusBar = ({ status, submittedAt, updatedAt, hasWarnings, jobReviewSuccess, jobAccountReviewed, accountSid }) => {
    const { gray800 } = useContext(ThemeContext).theme.tokens.colors;
    const { id: jobSid } = useParams();
    return (React.createElement(Box, { display: "flex", flexDirection: ['column', 'row'], flexWrap: "wrap", style: {
            gap: '15px',
            justifyContent: ['center', 'space-around'],
            alignItems: ['flex-start', 'center']
        } },
        React.createElement(Box, null,
            React.createElement(Label, { color: gray800, text: "Vouched Status" }),
            React.createElement(JobStatusLabel, { hasWarnings: hasWarnings, status: status })),
        typeof jobReviewSuccess === 'boolean' && (React.createElement(Box, null,
            React.createElement(Label, { color: gray800, text: "Review Status" }),
            React.createElement(JobStatusLabel, { hasWarnings: false, status: jobReviewSuccess ? 'approved' : 'rejected' }))),
        React.createElement(Box, null,
            React.createElement(Label, { color: gray800, text: "Submitted" }),
            React.createElement(Text, null, humanDate(submittedAt))),
        React.createElement(Box, null,
            React.createElement(Label, { color: gray800, text: "Updated" }),
            React.createElement(Text, null, updatedAt ? humanDate(updatedAt) : '-')),
        React.createElement(Box, null,
            React.createElement(Label, { color: gray800, text: "Job Id" }),
            React.createElement(Text, null, jobSid)),
        accountSid && (React.createElement(Box, null,
            React.createElement(Label, { color: gray800, text: "Account Id" }),
            React.createElement(Text, null,
                React.createElement(NavLink, { to: `/admin/accounts?sid=${accountSid}` }, accountSid)))),
        React.createElement(Box, null,
            React.createElement(Label, { color: gray800, text: "Viewed" }),
            React.createElement(ReviewedCheckbox, { jobAccountReviewed: jobAccountReviewed, jobSid: jobSid }))));
};
